import { getDatabase, ref, onValue, update } from 'firebase/database';

export const listenToNotifications = (userId, callback) => {
  const db = getDatabase();
  const notificationsRef = ref(db, `notifications/${userId}`);

  const unsubscribe = onValue(notificationsRef, (snapshot) => {
    if (!snapshot.exists()) {
      callback([]);
      return;
    }

    const activities = [];

    snapshot.forEach((notificationSnap) => {
      activities.push({
        id: notificationSnap.key,
        ...notificationSnap.val(),
      });
    });

    const sortedActivities = activities.sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0));

    callback(sortedActivities);
  });

  return unsubscribe;
};

export const updateNotificationRead = async (userId, id, read) => {
  const db = getDatabase();
  const notificationRef = ref(db, `notifications/${userId}/${id}`);

  await update(notificationRef, { read });
};
